export enum ChatProfileType {
  Author = 'Author',
  PartnerCrew = 'PartnerCrew',
}

export enum ProposalType {
  Publication = 'Publication',
  Etc = 'Etc',
}

export const ProposalTypeList = [ProposalType.Publication, ProposalType.Etc];

export const ProposalTypeString = {
  [ProposalType.Publication]: '출간 · 기고',
  [ProposalType.Etc]: '기타',
};

export enum ChatMessageType {
  Text = 'Text',
  Proposal = 'Proposal',
}

type BasePayload = {
  type: ChatMessageType;
  payload?: Record<string, any>;
};

export type ChatMessageInfoPayload = BasePayload & {
  type: ChatMessageType.Text;
};

export type ProposalMessageInfoPayload = BasePayload & {
  type: ChatMessageType.Proposal;
  payload: {
    proposalType: ProposalType;
    contentId: number;
  };
};

export interface ChatMessageExtraInfo {
  [ChatMessageType.Text]: ChatMessageInfoPayload;
  [ChatMessageType.Proposal]: ProposalMessageInfoPayload;
}

export enum ChatMessageOrder {
  Latest = 'Latest',
  Previous = 'Previous',
}
